import { Canvas } from "@dinahmoe/dmafjs-visual";

class StarryConnect extends Canvas {
  namespace = "visual:starry-connect";

  receiveMessage(node, message) {
    if (message.key === "starTriggered") {
      const now = Date.now();
      if (!node._lastStarDispatch || now - node._lastStarDispatch >= 100) {
        node._lastStarDispatch = now;
        this.dispatch("audio:star:triggered");
      }
    }

    super.receiveMessage(node, message);
  }
}

const starryConnect = new StarryConnect();
export { StarryConnect, starryConnect };
